import { Badge } from '@components/ui/badge';
import { getTechnologyContributorStatus } from '@utils/technology-contributor.util';

type TechnologyContributorStatusBadgeProps = {
  contributionsEndDate?: string | null;
};

export const TechnologyContributorStatusBadge: React.FC<TechnologyContributorStatusBadgeProps> = (props) => {
  const { contributionsEndDate } = props;

  const status = getTechnologyContributorStatus({ contributionsEndDate });

  if (status === 'past') {
    return <Badge variant="secondary">Past Contributor</Badge>;
  }

  return <Badge variant="success">Active Contributor</Badge>;
};
